import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '../../services/auth.service'
import { UsersService } from '../../services/users.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'

@Component({
  selector: 'ld-login',
  template: require('./login.component.html'),
  styles: [require('./login.component.css')]
})
export class LoginComponent {

  public email = ''
  public password = ''

  constructor (
    private authService: AuthService,
    private usersService: UsersService,
    private router: Router,
    private messagesDelegate: MessagesDelegate) {}

  async onSubmit () {
    try {
      const data = await this.authService.login(this.email, this.password)
      this.usersService.currentUser.cast(data)
      this.router.navigate(['/'])
    } catch (err) {
      this.usersService.currentUser.reset()
      this.messagesDelegate.add(err.message)
    }
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/login/login.component.ts